(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2],{

/***/ 6245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "InvalidTokenError": function() { return /* binding */ n; }
/* harmony export */ });
function e(e){this.message=e}e.prototype=new Error,e.prototype.name="InvalidCharacterError";var r="undefined"!=typeof window&&window.atob&&window.atob.bind(window)||function(r){var t=String(r).replace(/=+$/,"");if(t.length%4==1)throw new e("'atob' failed: The string to be decoded is not correctly encoded.");for(var n,o,a=0,i=0,c="";o=t.charAt(i++);~o&&(n=a%4?64*n+o:o,a++%4)?c+=String.fromCharCode(255&n>>(-2*a&6)):0)o="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);return c};function t(e){var t=e.replace(/-/g,"+").replace(/_/g,"/");switch(t.length%4){case 0:break;case 2:t+="==";break;case 3:t+="=";break;default:throw"Illegal base64url string!"}try{return function(e){return decodeURIComponent(r(e).replace(/(.)/g,(function(e,r){var t=r.charCodeAt(0).toString(16).toUpperCase();return t.length<2&&(t="0"+t),"%"+t})))}(t)}catch(e){return r(t)}}function n(e){this.message=e}function o(e,r){if("string"!=typeof e)throw new n("Invalid token specified");var o=!0===(r=r||{}).header?0:1;try{return JSON.parse(t(e.split(".")[o]))}catch(e){throw new n("Invalid token specified: "+e.message)}}n.prototype=new Error,n.prototype.name="InvalidTokenError";/* harmony default export */ __webpack_exports__["default"] = (o);
//# sourceMappingURL=jwt-decode.esm.js.map


/***/ }),

/***/ 545:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/success",
      function () {
        return __webpack_require__(2750);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zW": function() { return /* binding */ Events; },
  "sn": function() { return /* binding */ PageNames; },
  "c7": function() { return /* binding */ PageTypes; },
  "Vk": function() { return /* binding */ handleAccountPageEvent; },
  "qH": function() { return /* binding */ handleHomePageEvent; },
  "GV": function() { return /* binding */ handleTrackEvent; },
  "jV": function() { return /* binding */ mountDataLayer; },
  "l9": function() { return /* binding */ setPageAnalyticsData; }
});

// UNUSED EXPORTS: EventTypes, generatePageName

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/Cookies.js
var Cookies = __webpack_require__(5501);
// EXTERNAL MODULE: ./lib/analytics/segment/index.ts + 2 modules
var segment = __webpack_require__(4292);
;// CONCATENATED MODULE: ./lib/analytics/index.ts

var initiated = false;
var LCP_TIME = 6000;
var init = function() {
    window.segmentFlushQueue = flushQueue;
    if (initiated) return true;
    initSegment();
    initiated = true;
    window.addEventListener("unload", function() {
        flushQueue();
    });
    return initiated;
};
var handleAnalytics = function(event) {
    (0,segment/* segmentTrackEvent */.R7)(event);
};
var timedOutInit = function() {
    if (initiated) return true;
    setTimeout(function() {
        return init();
    }, LCP_TIME);
    return true;
};

// EXTERNAL MODULE: ./constants/index.ts
var constants = __webpack_require__(1407);
// EXTERNAL MODULE: ./lib/utils/helper.ts
var helper = __webpack_require__(9981);
// EXTERNAL MODULE: ./lib/utils/getConfig.ts + 1 modules
var getConfig = __webpack_require__(889);
;// CONCATENATED MODULE: ./lib/analytics/trackCalls.ts








var EventTypes;
(function(EventTypes) {
    EventTypes["PAGE"] = "page";
    EventTypes["TRACK"] = "track";
})(EventTypes || (EventTypes = {}));
var Events;
(function(Events) {
    Events["BUTTON_LINK_SELECTED"] = "Button Link Selected";
    Events["SUBMIT"] = "Submit";
    Events["SUBMIT_CODE_LANDING"] = "Submit Code Landing";
    Events["SUBMIT_CODE_STARTED"] = "Submit Code Started";
    Events["SUBMIT_CODE_COMPLETED"] = "Submit Code Completed";
    Events["PROFILE_ACCESS_ACTIVATION_STARTED"] = "Profile Access Activation Started";
    Events["PROFILE_ACCESS_ACTIVATION_COMPLETED"] = "Profile Access Activation Completed";
    Events["PROFILE_ACCESS_ACTIVATION_ERROR"] = "Profile Access Activation Error";
    Events["PROFILE_INITIATED"] = "Profile Initiated";
    Events["PROFILE_PROMPT_LANDING"] = "Profile Prompt Landing";
    Events["PROFILE_SIGN_IN_STARTED"] = "Profile Sign In Started";
    Events["PROFILE_SIGN_UP_STARTED"] = "Profile Sign Up Started";
    Events["PROFILE_SIGN_IN_COMPLETED"] = "Profile Sign In Completed";
    Events["PROFILE_SIGN_UP_COMPLETED"] = "Profile Sign Up Completed";
})(Events || (Events = {}));
var FOX_PREFIX = "delta";
var NATION_PREFIX = "nation";
var SPORT_PREFIX = "nation sport";
var PageNames;
(function(PageNames) {
    PageNames["SUBMIT_CODE_LANDING"] = "submit code landing";
    PageNames["PROFILE_PROMPT_LANDING"] = "profile prompt:landing";
})(PageNames || (PageNames = {}));
var PageTypes;
(function(PageTypes) {
    PageTypes["ACTIVATION_CODE"] = "activation code";
    PageTypes["PROFILE_PROMPT"] = "profile prompt";
})(PageTypes || (PageTypes = {}));
var _obj;
var getClientPrefix = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* Brand.FOX */.H2.FOX, FOX_PREFIX), (0,_define_property/* default */.Z)(_obj, constants/* Brand.SPORTS */.H2.SPORTS, SPORT_PREFIX), (0,_define_property/* default */.Z)(_obj, constants/* Brand.NATION */.H2.NATION, NATION_PREFIX), _obj);
var ACTIVATION_METHOD = "2nd screen";
var APP_PLATFORM = "web";
var FOX = "fox";
var FOX_DOMAIN = "fox.com";
var NATION_DOMAIN = "foxnews.com";
var ANONYMOUS_ID_COOKIE = "lastAnonymousProfileId";
var PAGE_TYPE = "ott";
var PRIMARY_BUSINESS_UNIT = "fng";
var PROFILE_ID_COOKIE = "secondScreenProfileId";
var START_SOURCE = "general";
var APP_CLIENT_PREFIX = getClientPrefix["nation"];
var defaultTraits = {
    appsflyer_id: "",
    dcg_profile_id: "",
    lastAnonymousProfileId: "",
    lastKnownProfileId: "",
    mvpd: "",
    network_entitlement_list: "",
    us_privacy: ""
};
// TODO: Update BRAND and DEVICE for Nation
// const DEVICE = account?.device ?? 'FOX';
var BRAND = FOX;
var DEVICE = "FOX";
var defaultProps = {
    app_name: "nation" || 0,
    app_platform: APP_PLATFORM,
    // TODO: set app version dynamically
    app_version: "1.0.0",
    page_name: ACTIVATION_METHOD,
    page_profile_activation_method: ACTIVATION_METHOD,
    page_start_source: START_SOURCE,
    page_type: PAGE_TYPE,
    primary_business_unit: PRIMARY_BUSINESS_UNIT,
    secondary_business_unit: "nation" || 0
};
var handleTrackEvent = function() {
    for(var _len = arguments.length, events = new Array(_len), _key = 0; _key < _len; _key++){
        events[_key] = arguments[_key];
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = _step.value, eventName = _value.eventName, props = _value.props, context = _value.context, eventType = _value.eventType;
            var ref, ref1;
            var cookies = new Cookies/* default */.Z();
            var ref2;
            var profileId = (ref2 = cookies.get(PROFILE_ID_COOKIE)) !== null && ref2 !== void 0 ? ref2 : "";
            var ref3;
            var codeInfoCookie = (ref3 = cookies.get(constants/* COOKIE_CODE_INFO */.r5)) !== null && ref3 !== void 0 ? ref3 : {};
            var campaignCodes = fetchCampaignCodes();
            // TODO: Find out why campaignCodes are different for different events
            if (eventName === Events.PROFILE_ACCESS_ACTIVATION_COMPLETED) {
                var ref4;
                var compaignCodesCookie = (ref4 = cookies.get(constants/* COOKIE_CAMPAIGN_CODES */.gV)) !== null && ref4 !== void 0 ? ref4 : "";
                campaignCodes = parseCampaignParams(compaignCodesCookie);
            }
            var traits = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultTraits, campaignCodes), {
                dcg_profile_id: profileId,
                lastAnonymousProfileId: getAnonymousId(),
                lastKnownProfileId: profileId
            });
            var ref5;
            var argsPageName = (ref5 = props === null || props === void 0 ? void 0 : props.page_name) !== null && ref5 !== void 0 ? ref5 : null;
            var ref6;
            var currentPageName = (ref6 = (ref = window.DataLayer) === null || ref === void 0 ? void 0 : ref.page_name) !== null && ref6 !== void 0 ? ref6 : null;
            var pageName = argsPageName !== null && argsPageName !== void 0 ? argsPageName : currentPageName;
            var genericPageName = generatePageName({
                pageName: pageName
            });
            var ref7;
            var argsPageType = (ref7 = props === null || props === void 0 ? void 0 : props.page_type) !== null && ref7 !== void 0 ? ref7 : null;
            var ref8;
            var currentPageType = (ref8 = (ref1 = window.DataLayer) === null || ref1 === void 0 ? void 0 : ref1.page_type) !== null && ref8 !== void 0 ? ref8 : null;
            var pageType = argsPageType !== null && argsPageType !== void 0 ? argsPageType : currentPageType;
            var ref9;
            var argsActivationCode = (ref9 = props === null || props === void 0 ? void 0 : props.page_activation_code) !== null && ref9 !== void 0 ? ref9 : null;
            var _code;
            var currentActiovationCode = (_code = codeInfoCookie.code) !== null && _code !== void 0 ? _code : null;
            var activationCode = argsActivationCode !== null && argsActivationCode !== void 0 ? argsActivationCode : currentActiovationCode;
            var newContext = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, context), {
                traits: traits
            });
            var finalProps = (0,helper.cleanObject)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultProps), {
                page_name: genericPageName,
                page_type: pageType,
                page_activation_code: activationCode
            }), props));
            handleAnalytics({
                eventName: eventName,
                props: finalProps,
                eventType: eventType,
                context: newContext
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
};
var generatePageName = function(param) {
    var pageName = param.pageName;
    return "".concat(APP_CLIENT_PREFIX, ":").concat(APP_PLATFORM, ":").concat(pageName);
};
var handleHomePageEvent = function() {
    handleTrackEvent({
        eventName: Events.PROFILE_ACCESS_ACTIVATION_STARTED
    }, {
        eventName: Events.SUBMIT_CODE_STARTED
    }, {
        eventName: Events.SUBMIT_CODE_LANDING,
        eventType: EventTypes.PAGE
    });
};
var handleAccountPageEvent = function() {
    handleTrackEvent({
        eventName: Events.PROFILE_PROMPT_LANDING,
        eventType: EventTypes.PAGE
    });
};
var getAnonymousId = function() {
    var ref;
    var cookies = new Cookies/* default */.Z();
    var user = (ref = window.analytics) === null || ref === void 0 ? void 0 : ref.user;
    var ref1;
    var lastAnonymousProfileId = (ref1 = cookies.get(ANONYMOUS_ID_COOKIE)) !== null && ref1 !== void 0 ? ref1 : "";
    var networkDomain;
    if (BRAND === FOX) networkDomain = FOX_DOMAIN;
    else networkDomain = NATION_DOMAIN;
    if (lastAnonymousProfileId) {
        cookies.set(ANONYMOUS_ID_COOKIE, lastAnonymousProfileId, {
            domain: networkDomain
        });
        return lastAnonymousProfileId;
    }
    var anonymousId = user ? user().anonymousId() : null;
    // TODO: Finds out why it is here
    cookies.set(ANONYMOUS_ID_COOKIE, anonymousId, {
        domain: networkDomain
    });
    return anonymousId;
};
var mountDataLayer = function() {
    window.DataLayer = {};
};
var setPageAnalyticsData = function(param) {
    var pageName = param.pageName, pageType = param.pageType;
    if (!window.DataLayer) mountDataLayer();
    window.DataLayer.page_name = pageName;
    window.DataLayer.page_type = pageType;
};
var parseCampaignParams = function(queryString) {
    if (!queryString) return {};
    var cleanQueryString = queryString.split("undefinedUnknown")[0];
    var segmentCampaign = "cmpid";
    var propertyNames = {
        cmpid: "campaign_int_tracking_code",
        int_cmp: "campaign_int_name"
    };
    var params = {};
    var ref;
    var cleanCampaignString = (ref = cleanQueryString.match(/^[^&]*/)) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var campaignString = (ref1 = cleanCampaignString[0]) !== null && ref1 !== void 0 ? ref1 : "";
    params[propertyNames[segmentCampaign]] = campaignString;
    var campaignCodes = campaignString.split("::");
    (campaignCodes || []).forEach(function(codes) {
        var keyValuesPair = codes.split("=");
        if (keyValuesPair.length === 2) {
            var ref;
            var key = (ref = keyValuesPair[0]) !== null && ref !== void 0 ? ref : "";
            var ref1;
            var value = (ref1 = keyValuesPair[1]) !== null && ref1 !== void 0 ? ref1 : "";
            var _key;
            var property = (_key = propertyNames[key]) !== null && _key !== void 0 ? _key : "";
            params[property] = value;
        }
    });
    return (0,helper.cleanObject)(params);
};
var fetchCampaignCodes = function() {
    var ref;
    var intCmp = (ref = getParameterByName(constants/* INT_CMP */.vl)) !== null && ref !== void 0 ? ref : null;
    // if (intCmp == null) return null;
    var intOrg = "dcg";
    // TODO: Get brand from
    var intMc = BRAND;
    var ref1;
    var intSrc = (ref1 = getDeviceFromProvidersByKey()) !== null && ref1 !== void 0 ? ref1 : DEVICE;
    var intAdd = intMc + (intSrc ? "_" + intSrc : "") + (intCmp ? "_" + intCmp : "");
    var codes = (0,helper.cleanObject)({
        int_org: intOrg,
        int_mc: intMc !== null && intMc !== void 0 ? intMc : null,
        int_src: intSrc !== null && intSrc !== void 0 ? intSrc : null,
        int_cmp: intCmp !== null && intCmp !== void 0 ? intCmp : null,
        int_add: intAdd !== null && intAdd !== void 0 ? intAdd : null
    });
    codes.campaign_int_tracking_code = formatCampaignString(codes);
    return codes;
};
var getParameterByName = function getParameterByName(name) {
    var match = RegExp("[?&]" + name + "=([^&]*)").exec(window === null || window === void 0 ? void 0 : window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
};
var formatCampaignString = function(campaignCodes) {
    var campaignKeys = Object.keys(campaignCodes);
    return campaignKeys.reduce(function(acc, key, i) {
        var isLast = i === campaignKeys.length - 1;
        return acc + key + "=" + campaignCodes[key] + (!isLast ? "::" : "");
    }, "");
};
var getDeviceFromProvidersByKey = function() {
    var cookies = new Cookies/* default */.Z();
    var ref;
    var codeInfoCookie = (ref = cookies.get(constants/* COOKIE_CODE_INFO */.r5)) !== null && ref !== void 0 ? ref : "";
    var config = (0,getConfig/* getConfig */.i)();
    var ref1;
    var devices = (ref1 = config === null || config === void 0 ? void 0 : config.devices) !== null && ref1 !== void 0 ? ref1 : [];
    Object.entries(devices).forEach(function(element) {
        var deviceName = element[0];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var providerKeys = element[1]["providers-key"];
        if (providerKeys === codeInfoCookie || deviceName === providerKeys) return element;
    });
    return null;
};


/***/ }),

/***/ 2750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_cookie__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(708);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(9521);
/* harmony import */ var styles_colors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2317);
/* harmony import */ var styles_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9900);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6245);
/* harmony import */ var lib_hooks__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9434);
/* harmony import */ var lib_utils_configs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2670);
/* harmony import */ var lib_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(739);
/* harmony import */ var lib_utils_helper__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9981);
/* harmony import */ var lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5537);
/* harmony import */ var context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1387);
/* harmony import */ var context_state_reducer__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(2807);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(1407);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    max-width: 500px;\n    margin: auto;\n    padding-top: 6rem;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding-top: 3rem;\n  margin: 0 auto;\n  height: 100%;\n  font-size: 16px;\n  text-align: center;\n  ",
        "\n  h1 {\n    font-family: 'Graphik', serif;\n    font-size: 30px;\n    font-weight: 600;\n    letter-spacing: -0.38px;\n    line-height: 37px;\n    text-align: center;\n  }\n\n  p {\n    margin: 0 0 1.5rem;\n    color: ",
        ";\n    font-family: 'Graphik', serif;\n    font-size: 24px;\n    font-weight: 300;\n    font-style: normal;\n    letter-spacing: -0.3px;\n    line-height: 30px;\n    opacity: 0.5;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
















var Success = function(param) {
    var profile = param.profile;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(context_GlobalContextProvider__WEBPACK_IMPORTED_MODULE_12__/* .AppContext */ .I), _state = ref.state, account = _state.account, config = _state.config, dispatch = ref.dispatch;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var isNation = (0,lib_hooks__WEBPACK_IMPORTED_MODULE_7__/* .useFlowManager */ .ix)().isNation;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,react_cookie__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)([
        constants_index__WEBPACK_IMPORTED_MODULE_14__/* .ACCOUNT_COOKIE_NAME_FOX */ .EO,
        constants_index__WEBPACK_IMPORTED_MODULE_14__/* .COOKIE_CODE_INFO */ .r5
    ]), 1), cookies = ref1[0];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!(profile === null || profile === void 0 ? void 0 : profile.checkAdobeAuthN)) return;
        var updatedProfile;
        var urlParams = new URLSearchParams(window.location.search);
        var regCode = urlParams.get("regCode") || "";
        var validateAuth = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(function() {
                var ref, ref1, _tmp, accessToken, ref2, _COOKIE_CODE_INFO, codeInfoCookie, _tmp1, firstScreenDeviceId, authNResponse, _tmp2, accessToken1, mvpd, ref3, ref4, mvpdLoginStatus, _tmp3, foxLoginStatus, _tmp4, _tmp5, e;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_18__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _tmp = {};
                            return [
                                4,
                                (0,lib_utils_helper__WEBPACK_IMPORTED_MODULE_10__.setConfigToProfile)(profile, (_tmp.appName = lib_utils_configs__WEBPACK_IMPORTED_MODULE_8__/* .profileConfig.appName */ .Vc.appName, _tmp.appVersion = lib_utils_configs__WEBPACK_IMPORTED_MODULE_8__/* .profileConfig.appVersion */ .Vc.appVersion, _tmp.accessToken = (ref = cookies[constants_index__WEBPACK_IMPORTED_MODULE_14__/* .ACCOUNT_COOKIE_NAME_FOX */ .EO]) === null || ref === void 0 ? void 0 : ref.accessToken, _tmp))
                            ];
                        case 1:
                            updatedProfile = _state.sent();
                            accessToken = (0,jwt_decode__WEBPACK_IMPORTED_MODULE_6__["default"])((ref1 = cookies[constants_index__WEBPACK_IMPORTED_MODULE_14__/* .ACCOUNT_COOKIE_NAME_FOX */ .EO]) === null || ref1 === void 0 ? void 0 : ref1.accessToken);
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                10,
                                ,
                                12
                            ]);
                            return [
                                4,
                                (0,lib_utils__WEBPACK_IMPORTED_MODULE_9__/* .refreshToken */ .g$)(profile, account)
                            ];
                        case 3:
                            _state.sent();
                            if (!(0,lib_utils_helper__WEBPACK_IMPORTED_MODULE_10__.tokenValid)(accessToken)) return [
                                3,
                                9
                            ];
                            _tmp1 = {};
                            codeInfoCookie = (_COOKIE_CODE_INFO = cookies[constants_index__WEBPACK_IMPORTED_MODULE_14__/* .COOKIE_CODE_INFO */ .r5]) !== null && _COOKIE_CODE_INFO !== void 0 ? _COOKIE_CODE_INFO : _tmp1;
                            firstScreenDeviceId = codeInfoCookie.firstScreenDeviceId;
                            _tmp2 = {};
                            return [
                                4,
                                updatedProfile === null || updatedProfile === void 0 ? void 0 : (ref2 = updatedProfile.checkAdobeAuthN) === null || ref2 === void 0 ? void 0 : ref2.call(updatedProfile, (_tmp2.deviceId = firstScreenDeviceId, _tmp2.requestor = "fbc-fox", _tmp2.adobeauth = true, _tmp2))
                            ];
                        case 4:
                            authNResponse = _state.sent();
                            accessToken1 = authNResponse.accessToken, mvpd = authNResponse.mvpd;
                            if (!(accessToken1 || mvpd)) return [
                                3,
                                9
                            ];
                            _tmp3 = {};
                            return [
                                4,
                                updatedProfile === null || updatedProfile === void 0 ? void 0 : (ref3 = updatedProfile.setRegCodeStatus) === null || ref3 === void 0 ? void 0 : ref3.call(updatedProfile, (_tmp3.regCode = regCode, _tmp3.firstScreenVersion = "", _tmp3.secondScreenVersion = "", _tmp3.status = {
                                    loginType: "MVPD",
                                    state: "OK"
                                }, _tmp3))
                            ];
                        case 5:
                            mvpdLoginStatus = _state.sent().mvpdLoginStatus;
                            _tmp4 = {};
                            return [
                                4,
                                updatedProfile === null || updatedProfile === void 0 ? void 0 : (ref4 = updatedProfile.setRegCodeStatus) === null || ref4 === void 0 ? void 0 : ref4.call(updatedProfile, (_tmp4.regCode = regCode, _tmp4.firstScreenVersion = "", _tmp4.secondScreenVersion = "", _tmp4.status = {
                                    loginType: "FOX",
                                    state: "ABORTED"
                                }, _tmp4))
                            ];
                        case 6:
                            foxLoginStatus = _state.sent().foxLoginStatus;
                            if (!(mvpdLoginStatus === "OK" && foxLoginStatus === "ABORTED")) return [
                                3,
                                7
                            ];
                            dispatch((0,context_state_reducer__WEBPACK_IMPORTED_MODULE_13__/* .setFlowStage */ .Kc)(constants_index__WEBPACK_IMPORTED_MODULE_14__/* .FLOW_STAGE_MVPD_LINK */ .Bi));
                            _tmp5 = {};
                            (0,lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_11__/* .handleTrackEvent */ .GV)((_tmp5.eventName = lib_analytics_trackCalls__WEBPACK_IMPORTED_MODULE_11__/* .Events.PROFILE_ACCESS_ACTIVATION_COMPLETED */ .zW.PROFILE_ACCESS_ACTIVATION_COMPLETED, _tmp5));
                            return [
                                2
                            ];
                        case 7:
                            return [
                                4,
                                router.push(constants_index__WEBPACK_IMPORTED_MODULE_14__/* .ROUTE_HOME */ .XX)
                            ];
                        case 8:
                            _state.sent();
                            _state.label = 9;
                        case 9:
                            return [
                                2
                            ];
                        case 10:
                            e = _state.sent();
                            dispatch((0,context_state_reducer__WEBPACK_IMPORTED_MODULE_13__/* .setError */ .sT)(e));
                            return [
                                4,
                                router.push(constants_index__WEBPACK_IMPORTED_MODULE_14__/* .ROUTE_HOME */ .XX)
                            ];
                        case 11:
                            _state.sent();
                            return [
                                3,
                                12
                            ];
                        case 12:
                            return [
                                2
                            ];
                    }
                });
            });
            return function validateAuth() {
                return _ref.apply(this, arguments);
            };
        }();
        validateAuth();
    }, [
        profile,
        cookies,
        dispatch,
        router,
        config === null || config === void 0 ? void 0 : config.siteUrl,
        account,
        isNation
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledSuccess, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("h1", {
                children: [
                    "Thank you for signing in ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "with your TV Provider."
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("p", {
                children: [
                    "You may now return to your TV to begin your ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}),
                    "enhanced streaming experience."
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Success);
var StyledSuccess = styled_components__WEBPACK_IMPORTED_MODULE_19__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-1b291e0f-0"
})(_templateObject1(), styles_helper__WEBPACK_IMPORTED_MODULE_5__/* .respondTo.bp_767 */ .s.bp_767(_templateObject()), styles_colors__WEBPACK_IMPORTED_MODULE_4__/* ["default"].white25 */ .ZP.white25);


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(545); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);